import {Image} from './image';

export class ImagePageAttributes {
    sectionHeading: string;
    sectionSubHeading: string;
    images: Array<Image>;
}
